<template>
  <div>
    <form
      v-if="step == 1"
      @submit.prevent="validateForm"
    >
      <div v-html="$error.handle(error)" />
      <br>
      <input
        type="hidden"
        name="campaign"
        value="twendetulipe"
      >
      <div>
        <select
          v-model="quote.tenure"
          v-validate="'required'"
          name="tenure_duration"
          class="select-control"
        >
          <option value="0">
            Select Tenure Duration
          </option>
          <option value="30">
            30 Days
          </option>
          <option value="60">
            60 Days
          </option>
          <option value="90">
            90 Days
          </option>
          <option value="120">
            120 Days
          </option>
          <option value="150">
            150 Days
          </option>
          <option value="180">
            180 Days
          </option>
          <option value="210">
            210 Days
          </option>
          <option value="255">
            255 Days
          </option>
          <option value="270">
            270 Days
          </option>
          <option value="365">
            365 Days
          </option>
        </select>
        <div
          v-if="errors.has('tenure_duration')"
          class="help-block with-errors"
        >
          {{ errors.first('tenure_duration') }}
        </div>
      </div>

      <div>
        <v-select
          v-model="selected_counter_party"
          v-validate="'required'"
          :options="counter_parties"
          label="name"
          placeholder="Select Counter Party"
          name="counterparty"
        />
        <div
          v-if="errors.has('counterparty')"
          class="help-block with-errors"
        >
          {{ errors.first('counterparty') }}
        </div>
      </div>

      <div>
        <vue-numeric
          v-model="quote.amount"
          v-validate="'required'"
          name="amount"
          placeholder="Bid Amount (KSHS)"
        />
        <div
          v-if="errors.has('amount')"
          class="help-block with-errors"
        >
          {{ errors.first('amount') }}
        </div>
      </div>

      <div>
        <input
          v-model="quote.email"
          v-validate="'required|email'"
          type="email"
          name="email"
          autocomplete="email"
          minlength="5"
          placeholder="Email Address"
        >
        <div
          v-if="errors.has('email')"
          class="help-block with-errors"
        >
          {{ errors.first('email') }}
        </div>
      </div>

      <div>
        <input
          v-model="quote.phone"
          v-validate="'required|min:10|max:15'"
          type="text"
          name="phone"
          placeholder="Phone"
          autocomplete="tel-national"
        >
        <div
          v-if="errors.has('phone')"
          class="help-block with-errors"
        >
          {{ errors.first('phone') }}
        </div>
      </div>

      <div class="checkbox">
        <input
          v-model="terms"
          v-validate="'required'"
          type="checkbox"
          name="terms"
          value="1"
          checked="checked"
        >
        <label for="terms">I HAVE READ AND UNDERSTOOD THE <a
          href="#"
          @click.prevent="show_terms=true"
        >TERMS
          & CONDITIONS</a></label>
      </div>
      <div
        v-if="errors.has('terms')"
        class="help-block with-errors"
      >
        {{ errors.first('terms') }}
      </div>

      <div>
        <button type="submit">
          Submit
        </button>
      </div>
    </form>

    <template v-if="step == 2">
      <div class="sent text-light">
        <h4>Success!</h4>
        <p>The quotation of KES {{ $number.format(quote.amount) }} is:</p>
        <table class="table text-light">
          <tbody>
            <tr>
              <td>Bidbond charge</td>
              <td>{{ $number.format(price.bid_bond_charge) }}</td>
            </tr>
            <tr>
              <td>Excise duty</td>
              <td>{{ $number.format(price.excise_duty) }}</td>
            </tr>
            <tr>
              <td>Indemnity charge</td>
              <td>{{ $number.format(price.indemnity_cost) }}</td>
            </tr>
            <tr>
              <td><strong>Total</strong></td>
              <td><strong>KES {{ $number.format(price.total) }}</strong></td>
            </tr>
          </tbody>
        </table>
        <div style="text-align: center; margin-top: 30px;">
          <a
            href="#"
            class="btn btn-primary"
            @click.prevent="sendMail"
          ><i class="fa fa-envelope" /> SEND
            QUOTE TO MAIL</a>
          <br>
          <p style="margin: 20px 0;">
            OR
          </p>
          <a
            href="#"
            class="btn btn-primary"
            @click.prevent="generateBid"
          >GENERATE BIDBOND</a>
        </div>
      </div>
    </template>

    <template v-if="step == 3">
      <div class="sent text-light">
        <h4>Success!</h4>
        <p style="margin: 20px 0;">
          Your quote has been generated and sent to {{ quote.email }}
        </p>
        <router-link
          :to="{ name: 'login' }"
          class="btn btn-primary"
        >
          GENERATE BIDBOND
        </router-link>
      </div>
    </template>

    <modal
      :show-modal="show_terms"
      @close="show_terms=false"
    >
      <template v-slot:header>
        <h5>Terms and Conditions</h5>
      </template>
      <div>
        <terms />
      </div>
      <hr>
      <div class="form-group">
        <a
          href="#"
          class="btn btn-primary"
          @click.prevent="show_terms = false; terms=1"
        >Accept Terms and
          Conditions</a>
        <a
          href="#"
          class="btn btn-danger pull-right"
          @click.prevent="show_terms = false"
        >Cancel</a>
      </div>
    </modal>
  </div>
</template>

<script>
    import Terms from "@/components/Guest/Terms.vue";

    export default {
        components: {
            Terms
        },

        data() {
            return {
                quote: {
                    tenure: 0,
                    amount: '',
                    counterparty: '',
                    email: '',
                    phone: '',
                    country: 'kenya'
                },
                terms: '',
                step: 1,
                price: {},
                show_terms: false,
                error: '',
                selected_counter_party: ''
            }
        },
        computed: {
            counter_parties() {
                return this.$store.getters.getCounterParties;
            },
        },

        mounted() {
            this.fetch();
        },

        methods: {
            fetch() {
                if (!this.counter_parties.length) {
                    this.$store.dispatch("fetchCounterParties").then(() => {
                        this.loading = false;
                    });
                }
            },
            validateForm() {
                return this.$validator.validateAll().then(result => {
                    if (result) {
                        this.request();
                    }
                });
            },
            request() {
                if (this.selected_counter_party.id) {
                    this.quote.counterparty = this.selected_counter_party.id;

                    this.$axios.post('/api/v1/quote', this.quote).then(response => {
                        this.price = response.data;
                        this.step = 2;
                        this.error = '';
                    }).catch(error => {
                        this.error = error.response;
                    });
                }
            },

            sendMail() {
                this.$axios.post('/api/v1/send-quote', this.quote).then(response => {
                    this.price = response.data;
                    this.step = 3;
                }).catch(error => {
                    this.error = error.response;
                });
            },
            generateBid: function () {
                this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Login to generate a bidbond',
                    showConfirmButton: false,
                    timer: 1500
                });

                if (this.$router.currentRoute.name !== 'login') {
                    this.$router.replace({name: 'login'});
                }
            }
        }
    }
</script>
